/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, createRoute } from 'framework/routing';
import EmployeeAccountsCreationForm from './externalaccounts/creation/EmployeeAccountsCreationForm';
import AccountCreationContext from './externalaccounts/AccountCreationContext';
import { RUN_COMMAND_PERMISSION } from './privilegedAccessRouting';
import InternAccountsCreationForm from './externalaccounts/creation/InternAccountsCreationForm';
import EmployeeAccountsDeprovisionForm from './externalaccounts/deprovision/EmployeeAccountsDeprovisionForm';
import InternAccountsDeprovisionForm from './externalaccounts/deprovision/InternAccountsDeprovisionForm';

const PRIVILEGED_ROUTES_PATH = '/privileged';
const CREATE_USER_ACCOUNTS_PATH = '/workers/:employeeId/external-accounts';
const CREATE_CANDIDATE_ACCOUNTS_PATH = '/candidates/:candidateId/external-accounts';
const DEPROVISION_CANDIDATE_ACCOUNTS_PATH = '/candidates/:candidateId/external-accounts/deprovision';
const DEPROVISION_USER_ACCOUNTS_PATH = '/workers/:employeeId/external-accounts/deprovision';
const LEGACY_CREATE_USER_ACCOUNTS_PATH = '/employees/:employeeId/external-accounts';
const LEGACY_DEPROVISION_USER_ACCOUNTS_PATH = '/employees/:employeeId/external-accounts/deprovision';

const usePrivilegedRouts = () => {
  const baseRoute = createRoute({
    listRoute: PRIVILEGED_ROUTES_PATH,
  });

  return {
    ...baseRoute,
    createUserAccountsRoute: `${baseRoute.listRoute}${CREATE_USER_ACCOUNTS_PATH}`,
    createCandidateAccountsRoute: `${baseRoute.listRoute}${CREATE_CANDIDATE_ACCOUNTS_PATH}`,
    deprovisionCandidateAccountsRoute: `${baseRoute.listRoute}${DEPROVISION_CANDIDATE_ACCOUNTS_PATH}`,
    deprovisionUserAccountsRoute: `${baseRoute.listRoute}${DEPROVISION_USER_ACCOUNTS_PATH}`,
    legacyCreateUserAccountsRoute: `${baseRoute.listRoute}${LEGACY_CREATE_USER_ACCOUNTS_PATH}`,
    legacyDeprovisionUserAccountsRoute: `${baseRoute.listRoute}${LEGACY_DEPROVISION_USER_ACCOUNTS_PATH}`,
  };
};

const PrivilegedRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    createUserAccountsRoute,
    createCandidateAccountsRoute,
    deprovisionCandidateAccountsRoute,
    deprovisionUserAccountsRoute,
    legacyCreateUserAccountsRoute,
    legacyDeprovisionUserAccountsRoute,
  } = usePrivilegedRouts();

  return (
    <ProtectedRouter basePath={PRIVILEGED_ROUTES_PATH}>
      <Routes>
        <Route
          path={createUserAccountsRoute}
          element={
            <AccountCreationContext permissionToCheck={RUN_COMMAND_PERMISSION}>
              <EmployeeAccountsCreationForm />
            </AccountCreationContext>
          }
        />

        <Route
          path={deprovisionUserAccountsRoute}
          element={
            <AccountCreationContext permissionToCheck={RUN_COMMAND_PERMISSION}>
              <EmployeeAccountsDeprovisionForm />
            </AccountCreationContext>
          }
        />
        <Route
          path={legacyCreateUserAccountsRoute}
          element={
            <AccountCreationContext permissionToCheck={RUN_COMMAND_PERMISSION}>
              <EmployeeAccountsCreationForm />
            </AccountCreationContext>
          }
        />
        <Route
          path={legacyDeprovisionUserAccountsRoute}
          element={
            <AccountCreationContext permissionToCheck={RUN_COMMAND_PERMISSION}>
              <EmployeeAccountsDeprovisionForm />
            </AccountCreationContext>
          }
        />

        <Route
          path={createCandidateAccountsRoute}
          element={
            <AccountCreationContext permissionToCheck={RUN_COMMAND_PERMISSION}>
              <InternAccountsCreationForm />
            </AccountCreationContext>
          }
        />

        <Route
          path={deprovisionCandidateAccountsRoute}
          element={
            <AccountCreationContext permissionToCheck={RUN_COMMAND_PERMISSION}>
              <InternAccountsDeprovisionForm />
            </AccountCreationContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PrivilegedRouter.getRouterPath = () => `${PRIVILEGED_ROUTES_PATH}/*`;

export default PrivilegedRouter;
